import React from "react";
import { useMutation, useQuery } from "react-query";
import {
    _api_get_list_offboarding_users,
    _api_get_list_types_status,
    _api_patch_change_status,
} from "../api";
import { useForm } from "react-hook-form";
import useDialog from "../../../hooks/useDialog";
import { useToastGlobal } from "../../../stores/useToastGlobal";

const usePrepareOffboarding = () => {
    // * HOOKS
    // * HOOKS
    // * HOOKS
    const [open, setOpen, openDialog, closeDialog] = useDialog();
    const globalToast = useToastGlobal();

    // * CONSTANTES
    // * CONSTANTES
    // * CONSTANTES
    const QUERY_KEY_OFFBOARDING = "offboarding";

    // * USEFORM
    // * USEFORM
    // * USEFORM
    const methods = useForm({
        defaultValues: {
            new_status: { id: 6, key: 6, header: "Offboarding" },
            change_date: null,
            user_id: null,
        },
    });

    // * QUERIES && MUTATIONS
    // * QUERIES && MUTATIONS
    // * QUERIES && MUTATIONS
    const {
        isLoading: is_fetching_offboarding_users,
        data: list_offboarding_users,
    } = useQuery([QUERY_KEY_OFFBOARDING + "::get_list_users"], () => {
        return _api_get_list_offboarding_users();
    });

    const { isLoading: is_fetching_type_status, data: list_type_status = [] } =
        useQuery(
            [
                QUERY_KEY_OFFBOARDING + "::get_list_type_status",
                methods.watch("user_id"),
            ],
            () => {
                const user_id = methods.getValues("user_id");
                return _api_get_list_types_status({
                    id_user: user_id?.id,
                });
            },
            {
                enabled: methods.getValues("user_id") !== null,
            }
        );

    const { isLoading: is_loading_change_status, mutate } = useMutation(
        (data) => {
            return _api_patch_change_status(data);
        },
        {
            onSuccess: (data) => {
                if (data?.success) {
                    // show success alert
                    globalToast.setShow({
                        visible: true,
                        content:
                            "Le collaborateur a bien été ajouté afin de préparer son départ.",
                        level: "success",
                    });
                    beforeCloseDialog();
                    return;
                } else {
                    // show error alert
                    globalToast.setShow({
                        visible: true,
                        content: data.message,
                        level: "danger",
                    });
                }
            },
        }
    );

    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS
    const format_users_for_dropdown = (users = []) => {
        return users.map((user) => ({
            id: user.id,
            key: user.id,
            header: user.name,
            content: user.job_title,
            name: user.name,
            avatar: user.avatar,
            status: user.status,
        }));
    };
    const format_status_for_dropdown = (status = []) => {
        return status.map((sts) => ({
            id: sts.id,
            key: sts.id,
            header: sts.value,
        }));
    };

    const beforeCloseDialog = () => {
        methods.reset();
        closeDialog();
        return;
    };

    return {
        query_list_users: {
            data: list_offboarding_users,
            isLoading: is_fetching_offboarding_users,
            formated_data: format_users_for_dropdown(list_offboarding_users),
        },
        query_list_type_status: {
            data: list_type_status,
            isLoading: is_fetching_type_status,
            formated_data: format_status_for_dropdown(list_type_status),
        },
        methods: {
            ...methods,
            onSubmit: (data) => {
                mutate({
                    id_user: data.user_id.id,
                    data: {
                        new_status: data.new_status.id,
                        change_date: data.change_date,
                    },
                });
                return;
            },
        },
        mutation: {
            isLoading: is_loading_change_status,
            mutate: mutate,
        },
        dialog: {
            open,
            setOpen,
            openDialog,
            closeDialog,
            beforeCloseDialog,
        },
    };
};

export default usePrepareOffboarding;
